export default "__VITE_ASSET__8da376cc__"